module.exports = __webpack_public_path__ + "img/logo.2cf778c5.svg";